import { AlpineComponent } from "alpinejs";

type CallToActionButtonTracker = AlpineComponent<{
	trackCallToActionButtonClick: (buttonText: string, trackClickEvent: boolean) => void;
}>;

export default (): CallToActionButtonTracker => {
	return {
		trackCallToActionButtonClick(buttonText: string, trackClickEvent: boolean) {
			if (!trackClickEvent) {
				return;
			}
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "cta_button_click",
				link_text: buttonText,
			});
		},
	};
};
